import { Injectable } from '@angular/core';
import { ServiceRouter } from '../core/http-service-router.service';
import { Config } from '../../config/config';
import { METHOD_TYPE } from '../../constants/service.constants';
import { HealthFinding } from '../../beans/health-summary/health-summary.module.bean';
import { map, Observable } from 'rxjs';
import { Environment } from '../../config/environment';

@Injectable({
	providedIn: 'root',
})
export class HealthSummaryService {
	constructor(
		private serviceRouter: ServiceRouter,
		private environment: Environment,
		private config: Config
	) { }

	getHealthSummary(): Observable<HealthFinding> {
		const self = this;
		return self.serviceRouter.makeRequest(
			this.environment.getEnvironment().EPMS_PROXY_BASE_URL,
			self.config.url.healthSummary.getHealthSummary,
			METHOD_TYPE.SECURED_GET,
			''
		).pipe(
			map<HealthFinding, HealthFinding>(v1 => ({
				data: v1.data.map(v2 => ({
					...v2,
					description: v2.description?.replace(/|/ig, `"`)
				}))
			}))
		);
	}
}
